import React from 'react';

import { styled } from 'styled-components';

import MoreArticles from 'components/Article/ArticleSideContent/MoreArticles';
import PromoCta from 'components/Article/ArticleSideContent/PromoCta';
import ShareLinks from 'components/Article/ShareLinks';
import { MediaQuery } from 'components/StyledComponents/MediaQueryRendering';
import { TagProps } from 'components/Tags/Tag';
import Tags from 'components/Tags/Tags';

import { BlogCategoriesI, BlogPostI } from 'interfaces/content-stack/blogPost';

import { getFullUrl } from 'utils/linkResolver';

const ArticleSideContentWrapper = styled.div`
  @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
    margin-top: 2rem;
  }

  height: 100%;
  flex-direction: column;
  grid-template-columns: 1fr;
  grid-auto-columns: 1fr;
  align-content: start;
  display: grid;
`;

const SideSection = styled.div`
  margin-bottom: 2.5rem;
`;

export const SideSectionHeader = styled.div`
  margin-bottom: 1.25rem;
  font-size: 0.875rem;
  text-transform: uppercase;
  margin-top: 0;
  font-weight: 500;
  line-height: 1.6;
  font-family: ${(props) => props.theme.fonts.fontFamilySecondary};
`;

const StickySideSectionWrapper = styled.div`
  height: 100%;
  grid-row-gap: 2rem;
  flex-flow: column;
  display: flex;
  position: sticky;
  top: 10rem;
`;

interface ArticleSideContentProps {
  data: BlogPostI;
  siteUrl: string;
  allArticles: string;
}

const CategoriesToTags = (categories: BlogCategoriesI[] | undefined, allArticles: string): TagProps[] => {
  if (categories) {
    return categories.map((category) => {
      return {
        label: category.title,
        url: `${allArticles.replace(/\/*$/, '')}/?${category.title.replaceAll(' ', '+')}=true`,
        color: category.color,
      };
    });
  }
  return [];
};

const ArticleSideContent: React.FC<ArticleSideContentProps> = ({ data, siteUrl, allArticles }) => {
  const { sidebarCta, breadcrumb } = data;

  const sideSectionContent = [
    {
      label: 'Related',
      content: <Tags tags={CategoriesToTags(data.metadata.categories, allArticles)} />,
    },
    {
      label: 'More Articles',
      content: <MoreArticles featuredArticleId={data.id} />,
    },
  ];

  return (
    <ArticleSideContentWrapper data-elastic-exclude>
      {sideSectionContent.map((section, i) => (
        <SideSection key={i}>
          {section.label && <SideSectionHeader>{section.label}</SideSectionHeader>}
          {section.content}
        </SideSection>
      ))}

      <StickySideSectionWrapper>
        {sidebarCta && sidebarCta.map((cta, index) => <PromoCta data={cta} key={index} />)}
        <MediaQuery $desktop>
          <ShareLinks
            shareUrl={getFullUrl({
              siteUrl,
              pageSegment: data.url,
              breadcrumbSegment: breadcrumb?.[0]?.url,
            })}
          />
        </MediaQuery>
      </StickySideSectionWrapper>
    </ArticleSideContentWrapper>
  );
};

export default ArticleSideContent;
